<template>
  <div class="akl" v-if="ready">
    <div class="loading box_renew-loading" v-show="isLoading">
      <div class="loading-wrap">
      <span class="box_loading-area">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="100px" height="100px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
        <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
          <animateTransform attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.6s"
            repeatCount="indefinite"/>
          </path>
        </svg>
      </span>
      </div>
    </div>

    <div class="bod-view-txt">
      <div class="os_noticeRes">
        <artistryMakeoverHeader />
        <artistryMakeoverContent 
          ref="amc"
          :reserve="selectReserve" 
          :abcList="RESERVE_ABC" 
          :dayList="RESERVE_DAY" 
          :timeList="RESERVE_TIME" 
          :makeupList="MAKEUP_STYLE"
          :reservedTime="reservedTime"
          @abc="(changeAbc) => selectReserve = {abc : changeAbc, day: '', time: '', style: selectReserve.style}"
          @day="(changeDay) => time(changeDay)"
          @time="(changeTime) => selectReserve = {abc : selectReserve.abc, day: selectReserve.day, time: changeTime, style: selectReserve.style}"
          @style="(changeStyle) => selectReserve.style = changeStyle"
        />
        <artistryMakeoverJoin :login="isLogin" 
          :layers="layerReserve" 
          @alert="showLayer"
          @reserve="doReserve"
          @check="doReserveCheck(true)"
          @cancel="doReserveCancel"
          @amwayhome="goAmwayHome"
        />
        <artistryMakeoverFooter /> 
      </div>
    </div>
  <artistryMakeoverLayerPopup :layers="layerInfo" :reserve="layerReserve" />
  </div>
</template>

<script>
import Vue from 'vue'
// Component
import artistryMakeoverHeader from "./components/header";
import artistryMakeoverContent from "./components/content";
import artistryMakeoverJoin from "./components/join";
import artistryMakeoverFooter from "./components/footer";
import artistryMakeoverLayerPopup from "./components/layerPopup";

// Library
import axios from "axios";

const MAKEUP_STYLE = [{
  'value': 'dailylook',
  'alt': '데일리 룩',
  'desc': '얼굴의 윤곽과 이목구비를 자연스럽게 살려주는',
  'img': require('./images/cont_makeup_01.png')
}, {
  'value': 'datelook',
  'alt': '데이트 룩',
  'desc': '생기와 볼륨감을 화사하게 살려주는',
  'img': require('./images/cont_makeup_02.png')
}, {
  'value': 'moodlook',
  'alt': '무드 룩',
  'desc': '특별한 날 돋보일 수 있도록 화려하게 살려주는',
  'img': require('./images/cont_makeup_03.png')
}]

const SERVER_RESPONSE = {
    'RESERVED': 'pop_event_01',
    'SELECTED': 'pop_event_02',
    'CANCELLED': 'pop_event_03',
    'INVALID_ABO_NO': 'pop_event_07',
    'INVALID_ABO_NAME': 'pop_event_07',
    'INVALID_ABC': 'pop_event_08',
    'INVALID_DATE': 'pop_event_08',
    'INVALID_TIME': 'pop_event_08',
    'INVALID_STYLE': 'pop_event_08',
    'RESERVED_ME': 'pop_event_05',
    'RESERVED_OTHER': 'pop_event_05',
    'NOT_RESERVED': 'pop_event_06',    
    'BEING_DAY': 'pop_event_04',
    'CLODE_RESERVE_DAY': 'pop_event_04',
    'CLOSE_CANCEL_DAY': 'pop_event_04',
    'CLOSE_CHECK_DAY': 'pop_event_04',
    'OTHER_ERROR': 'pop_event_08'
}

export default {
  name: "artistry-makeover",
  components: {
    artistryMakeoverHeader,
    artistryMakeoverContent,
    artistryMakeoverJoin,
    artistryMakeoverFooter,
    artistryMakeoverLayerPopup,
  },
  data() {
    return {
      RESERVE_ABC: {},
      RESERVE_DAY: {},
      RESERVE_TIME: {},
      MAKEUP_STYLE,
      ready: true,
      layerInfo: { // 레이어 팝업 표시용 
        mode: SERVER_RESPONSE,
        selectItem : 'NOT_RESERVED' 
      },
      aboInfo : { // ABO 로그인 정보 (with Hybris OCC)
        aboNo: '',
        aboName: '',
      },
      selectReserve : { // 예약 선택 정보 
        abc: '',
        day: '',
        time: '',
        style: '',
      },
      layerReserve: { // 예약 확인 정보 
        abc: '',
        day: '',
        time: '',
        style: '',
        message: '',
      },
      reservedTime: [],
      isLoading: false
    };
  },
  computed: { 
    isLogin () { // 로그인 여부 
      return !this.aboInfo.aboNo == ''
    },
  },
  methods: {
    goAmwayHome: function(){ 
      document.location = process.env.AMWAY_ROOT_URL
    },
    init: async function () { // 초기화
      this.isLoading = true
      await this.doLogin()
      await this.code()
      await this.doReserveCheck(false)
      this.reset()
      this.isLoading = false
    },
    doLogin: async function () { // 로그인 체크
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
        }
      }).catch(ex => {
        console.log("ex : ", ex)
      })
    },
    showLayer: function (type, message){  // 레이어 활성화 
      this.layerInfo.selectItem = type
      this.layerReserve.message = message
      
      // class 반영되는데 약간의 지연이 발생되어 0.5 초 지연을 후 Layer Popup 을 띄움
      window.setTimeout(() => {
          layerPopOver(this, '.'+ this.layerInfo.mode[type])
      }, 200)
    },
    validation : function () { // 데이터 검증 
      // ABC 선택 여부 체크 
      if (this.selectReserve.abc == '') { 
        this.showLayer('INVALID_ABC', 'ABC를 선택해주세요.')
        return false
      }
      
      // 날짜 선택 여부 체크 
      if (this.selectReserve.day == '') { 
        this.showLayer('INVALID_DATE', '날짜를 선택해주세요.')
        return false
      }

      // 시간 선택 여부 체크
      if (this.selectReserve.time == '') { 
        this.showLayer('INVALID_TIME', '시간을 선택해주세요.')
        return false
      }

      // 스타일 선택 여부 체크 
      if (this.selectReserve.style == '') { 
        this.showLayer('INVALID_STYLE', '메이크업 룩을 선택해주세요.')
        return false
      }

      return true
    },
    code: async function () { 
      this.isLoading = true
      
      await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/artistry/makeover/code', {
        action: 'code'
      }).then(response => {
        this.RESERVE_ABC = response.data.abc
        this.RESERVE_DAY = response.data.day
        this.RESERVE_TIME = response.data.time
      }).catch(ex => {
        console.log("ex :", ex)
        this.showLayer('OTHER_ERROR', '죄송합니다. 처리가 지연되고 있습니다.<BR>다시 시도해 주세요.')
      })
      this.isLoading = false
    },
    time: async function (changeDay) { 
      this.isLoading = true
      this.selectReserve = {abc : this.selectReserve.abc, day: changeDay, time: '', style: this.selectReserve.style}
      await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/artistry/makeover/code', {
        action: 'time',
        ...this.selectReserve,
      }).then(response => {
        this.reservedTime = response.data.reserved
      }).catch(ex => {
        console.log("ex :", ex)
        this.showLayer('OTHER_ERROR', '죄송합니다. 처리가 지연되고 있습니다.<BR>다시 시도해 주세요.')
      })
      this.isLoading = false
    },
    join: async function(action) { // api 호출 : api > layer popup > reset 
      let result = {}
      this.isLoading = true

      await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/artistry/makeover', {
          action: action,
          ...this.selectReserve,
        }
      ).then(response => {
        result = response.data
      }).catch(ex => {
        console.log("ex :", ex)
        this.showLayer('OTHER_ERROR', '죄송합니다. 처리가 지연되고 있습니다.<BR>다시 시도해 주세요.')
      })

      this.isLoading = false
      return result
    },
    doReserve : async function () { // 예약하기
      if(!this.isLogin) { 
        this.showLayer('INVALID_ABO_NO', '홈페이지에 로그인 하신 뒤에 이용이 가능합니다.')
        return 
      }
      if( !this.validation() ) return 
      await this.join('reserve').then((status) => {
        this.showLayer(status.statusCode, status.statusMessage) // 서버 응답처리

        if (status.statusMessage == 'SUCCESS') {
          this.doReserveCheck(false)
        }
      })
      
      this.reset()
    },
    doReserveCheck: async function (showLayer) { // 예약확인하기 
      if(!this.isLogin) { 
        if (showLayer) this.showLayer('INVALID_ABO_NO', '홈페이지에 로그인 하신 뒤에 이용이 가능합니다.')
        return 
      }
      await this.join('check').then((data) => {
        // 정상적으로 조회된 내용이 있다면 layerReserve 에 복사 
        if (data.statusCode == 'SELECTED') { 
          this.layerReserve.abc = this.RESERVE_ABC[data.reserve.abc]
          this.layerReserve.day = this.RESERVE_DAY[data.reserve.day]
          this.layerReserve.time = this.RESERVE_TIME[data.reserve.time]
          this.layerReserve.style = this.MAKEUP_STYLE.find(x => x.value == data.reserve.style).alt        
        }else { 
          this.layerReserve = { // 예약 확인 정보 
            abc: '',
            day: '',
            time: '',
            style: '',
            message: '',
          }
        }
        if (showLayer) this.showLayer(data.statusCode, data.statusMessage) // 서버 응답처리
      })
    }, 
    doReserveCancel: async function () { // 예약취소하기
      if (!this.isLogin) {
        this.showLayer('INVALID_ABO_NO', '홈페이지에 로그인 하신 뒤에 이용이 가능합니다.')
        return 
      }
      await this.join('cancel').then((status) => { // api 호출 
        this.showLayer(status.statusCode, status.statusMessage) // 서버 응답처리
        if (status.statusMessage == 'SUCCESS') {
          this.doReserveCheck(false)
        }
      })
      
      this.reset()
    },
    reset() {
      this.selectReserve = { // 예약 선택 정보 
        abc: '',
        day: '',
        time: '',
        style: '',
      }
      this.$refs.amc.init()
    }
    
  },
  mounted: function() {
    window.setTimeout(() => { // 초기화 처리 
      this.ready = true
      this.init()
    }, 500)
  },
  created: async function() { // Markup script 로드 
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery-3.2.1.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery-ui-1.12.1.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery.colorbox-min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/jquery.flexslider.js')

    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/owl.carousel.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/owl.carousel.custom.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/bootstrap.min.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/swiper.min.js')

    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/common/akl_common.js')
    await Vue.loadScript('https://www.amway.co.kr/_ui/responsive/common/js/common/akl_contents.js')
  }
};
</script>

<style scoped>
/* css 디자인 로드 */
@import "./css/font_kr.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css";
@import "https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-new-v2.css";

.loading.box_renew-loading {
    background: transparent
}

.akl {
  padding-left: 15px;
  padding-right: 15px;
}

</style>



// WEBPACK FOOTER //
// src/views/artistry/makeover/index.vue